import { defineComponent as i, toRef as n, h as e } from "vue";
import d from "./ghl-ui.es1482.js";
import c from "./ghl-ui.es900.js";
import g from "./ghl-ui.es896.js";
const p = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
}, w = i({
  name: "BaseLoading",
  props: Object.assign({ clsPrefix: {
    type: String,
    required: !0
  }, show: {
    type: Boolean,
    default: !0
  }, scale: {
    type: Number,
    default: 1
  }, radius: {
    type: Number,
    default: 100
  } }, p),
  setup(s) {
    c("-base-loading", d, n(s, "clsPrefix"));
  },
  render() {
    const { clsPrefix: s, radius: r, strokeWidth: a, stroke: t, scale: l } = this, o = r / l;
    return e(
      "div",
      { class: `${s}-base-loading`, role: "img", "aria-label": "loading" },
      e(g, null, {
        default: () => this.show ? e(
          "div",
          { key: "icon", class: `${s}-base-loading__transition-wrapper` },
          e(
            "div",
            { class: `${s}-base-loading__container` },
            e(
              "div",
              { class: `${s}-base-loading__container-layer` },
              e(
                "div",
                { class: `${s}-base-loading__container-layer-left` },
                e(
                  "svg",
                  { class: `${s}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: t } },
                  e("circle", { fill: "none", stroke: "currentColor", "stroke-width": a, "stroke-linecap": "round", cx: o, cy: o, r: r - a / 2, "stroke-dasharray": 4.91 * r, "stroke-dashoffset": 2.46 * r })
                )
              ),
              e(
                "div",
                { class: `${s}-base-loading__container-layer-patch` },
                e(
                  "svg",
                  { class: `${s}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: t } },
                  e("circle", { fill: "none", stroke: "currentColor", "stroke-width": a, "stroke-linecap": "round", cx: o, cy: o, r: r - a / 2, "stroke-dasharray": 4.91 * r, "stroke-dashoffset": 2.46 * r })
                )
              ),
              e(
                "div",
                { class: `${s}-base-loading__container-layer-right` },
                e(
                  "svg",
                  { class: `${s}-base-loading__svg`, viewBox: `0 0 ${2 * o} ${2 * o}`, xmlns: "http://www.w3.org/2000/svg", style: { color: t } },
                  e("circle", { fill: "none", stroke: "currentColor", "stroke-width": a, "stroke-linecap": "round", cx: o, cy: o, r: r - a / 2, "stroke-dasharray": 4.91 * r, "stroke-dashoffset": 2.46 * r })
                )
              )
            )
          )
        ) : e("div", { key: "placeholder", class: `${s}-base-loading__placeholder` }, this.$slots)
      })
    );
  }
});
export {
  w as default
};
